import type { APISlideAttributes, ArdoqId } from '@ardoq/api-types';
import type {
  Slide,
  SlideNavigatorState,
} from 'presentation/slideNavigator/types';
import type { LoadedPresentationState } from 'presentation/streams/loadedPresentation$';
import { getScenario } from 'presentation/presentationData';
import type { CollectionStream } from 'streams/utils/streamUtils';
import {
  toPlannedSlides,
  type PlannedSlide,
  type ToRenderedViewId,
} from './slidePlan';

export type RunContext = {
  presentationName: string | undefined;
  slides: PlannedSlide[];
  startingSlideId: ArdoqId | null;
  wasExploreMode: boolean;
};

export const toRunContext = (
  { presentation }: Pick<LoadedPresentationState, 'presentation'>,
  { byId }: Pick<CollectionStream<APISlideAttributes>, 'byId'>,
  titles: Pick<Slide, 'id' | 'title'>[],
  {
    selectedSlideId,
    isExploreMode,
  }: Pick<SlideNavigatorState, 'selectedSlideId' | 'isExploreMode'>,
  toRenderedViewId: ToRenderedViewId
): RunContext => ({
  presentationName: presentation?.name,
  slides: toPlannedSlides({
    presentation,
    slidesById: byId,
    titleById: new Map(titles.map(({ id, title }) => [id, title])),
    classifiers: {
      toRenderedViewId,
      hasScenario: scenarioId => Boolean(getScenario(presentation, scenarioId)),
    },
  }),
  startingSlideId: selectedSlideId,
  wasExploreMode: isExploreMode,
});
